import PageHero from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { useSite } from "../context/SiteContext";

export default function Courses() {
  const { courses, settings } = useSite();
  const p = settings.pages.course;
  return (
    <div data-testid="course-page">
      <PageHero label={p.label} title={p.title} subtitle={p.subtitle} />
      <section className="bg-bone py-20 md:py-28">
        <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16 space-y-px bg-line border border-line">
          {courses.map((c, i) => (
            <Reveal key={c.id || c.code || i} delay={i * 0.05}>
              <div data-testid="course-item" className="bg-bone grid grid-cols-1 md:grid-cols-12 gap-6 p-8 md:p-12 group hover:bg-forest transition-colors duration-300">
                <div className="md:col-span-1"><span className="font-mono text-sm text-gold">{c.code}</span></div>
                <div className="md:col-span-4">
                  <h3 className="font-serif text-3xl md:text-4xl text-forest group-hover:text-bone transition-colors">{c.title}</h3>
                  <p className="text-xs uppercase tracking-widest text-gold mt-3">{c.years}</p>
                </div>
                <div className="md:col-span-4"><p className="text-muted group-hover:text-bone/60 transition-colors leading-relaxed">{c.desc}</p></div>
                <div className="md:col-span-3">
                  <p className="text-xs uppercase tracking-widest text-forest/40 group-hover:text-bone/40 transition-colors mb-3">Subjects</p>
                  <ul className="space-y-1">
                    {(c.subjects || []).map((s) => <li key={s} className="text-sm text-forest group-hover:text-bone transition-colors">{s}</li>)}
                  </ul>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
